import type { RootState } from 'src/store';

/**
 * Gets keycloak token from redux store
 * @param state
 * @returns Record<string, string>
 */
export const getKcToken = (state: RootState) => state.kcToken;
